import configureLogger from "asos-web-logging";
import { configureRequest } from "@asosteam/asos-web-request";

const logger = configureLogger({
  moduleName: "post-mastercard-competition-entry-client-side",
  maxLogLevel: "info",
});

export const requestHelper = configureRequest({
  defaultTimeout: 10000,
  logger,
  client: {
    name: "asos-web-content-pages",
    version: "1.0.0",
    platform: "Web",
  },
});
